export const WEEKDAYS_MONDAY_FIRST = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Blank cells before the 1st of the month when weeks start on Monday (Sunday = 6)
export const mondayFirstOffset = date =>
    (new Date(date.getFullYear(), date.getMonth(), 1).getDay() + 6) % 7;
